/**
 * The class for a field Oracle fills and the user cannot edit, on the root of a
 * design-system `Input` rendered `readOnly`. A grey fill says so, where the
 * design system's own disabled fill, bg-secondary (#FAFAF9), is too close to
 * white to read as a state, and its disabled text is too faint to read the
 * value by.
 */
export const LOCKED_FIELD = [
  'bg-[var(--ds-color-bg-secondary-dark)]',
  // Input.css colours the field itself, so the root's colour would not reach it.
  '[&_input]:cursor-default [&_input]:text-[color:var(--ds-color-raw-stone-600)]',
].join(' ');
